import EnquiryPageShell from '@/components/feature/EnquiryPageShell';
import EnquiryForm from '@/components/feature/EnquiryForm';
import { Field, SelectField, TextareaField } from '@/components/base/FormFields';

export default function DreamTeam() {
  return (
    <EnquiryPageShell
      eyebrow="Event Dream Team"
      title="Build My Event Dream Team"
      intro={
        <>
          <p>
            Planning an event that needs several talented suppliers? Share your vision once, and
            Daniella will source suitable professionals, check their fit where possible and make
            thoughtful introductions.
          </p>
          <p>
            This is an introduction service only. It is not event planning or coordination, and
            categories, scope and timeframe are agreed before acceptance.
          </p>
          <p>
            The service starts at £199. Your requirements will be reviewed personally by Daniella,
            and the final quotation will reflect the number of supplier categories and the complexity
            of the sourcing required. You&rsquo;ll receive a clear proposal before making any payment.
          </p>
        </>
      }
      price="From £199"
      priceNote="Subject to a personal quotation. No payment is requested until the scope and price have been agreed."
    >
      <EnquiryForm
        submitAddr="https://readdy.ai/api/form/db6hqckbe24agvuu3jqg"
        formId="event_dream_team"
        categoryMode="multiple"
        submitLabel="Submit My Event Brief"
        requirementsMaxLength={1500}
        eventDateMode="text"
        supplierBudgetLabel="Budget for suppliers we source"
        supplierBudgetHint="The amount available for the suppliers KOR38 is sourcing — separate from your overall event budget."
        priceNote="From £199. Your requirements will be reviewed personally by Daniella. The final quotation will reflect the number of supplier categories and complexity of the sourcing required. You'll receive a clear proposal before making any payment. No automatic checkout."
        successMessage="Thank you — your event brief has been received for Daniella's review. She'll confirm scope and next steps if the request is accepted."
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Field
            label="Approximate guest numbers"
            name="guest_numbers"
            inputMode="numeric"
            required
            placeholder="e.g. 80"
          />
          <Field
            label="Overall event budget"
            name="overall_budget"
            required
            placeholder="e.g. £10,000"
            hint="Your total budget for the whole event — separate from the budget for the suppliers we source above."
          />
          <Field label="Style or theme" name="style_theme" placeholder="e.g. Elegant, minimalist, festive" />
          <SelectField
            label="Flexible on date or location?"
            name="flexibility"
            options={['Yes — flexible on both', 'Flexible on date only', 'Flexible on location only', 'No — fixed']}
            required
          />
        </div>
        <TextareaField
          label="Suppliers already booked"
          name="suppliers_booked"
          rows={3}
          placeholder="If you've already booked anyone, let us know so we avoid duplication."
        />
        <TextareaField
          label="Special needs or considerations"
          name="special_needs"
          rows={3}
          placeholder="Accessibility, dietary requirements, cultural considerations or anything important."
        />
      </EnquiryForm>
    </EnquiryPageShell>
  );
}